export const TWO_FA_TYPES = {
  Email: 'Email',
  Authenticator: 'AuthenticatorApplication',
  Phone: 'Phone',
};
